import { useEffect, useState } from 'react';

import { TabT } from '.';

import { Tab, Tabs } from '@mui/material';
import { useLocation } from 'react-router-dom';

interface TabsOrganizeProps {
  tabs: TabT[];
  // eslint-disable-next-line no-unused-vars
  onChange?: (newTabName: string) => void;
  // eslint-disable-next-line no-unused-vars
  onFirstTimeTabIsLoaded?: (newTabName: string) => void;
}
function TabsOrganize({
  tabs,
  onChange,
  onFirstTimeTabIsLoaded,
}: TabsOrganizeProps) {
  const [value, setValue] = useState<string | null>(null);
  const [alreadyLoadedTabs, setAlreadyLoadedTabs] = useState<string[]>([]);
  const { hash } = useLocation();

  const setNewTab = (newValue: string) => {
    setValue(newValue);
    // Set hash url
    window.history.replaceState(null, '', `#${newValue}`);
  };

  const pushAlreadyLoadedTabs = (newValue: string) => {
    setAlreadyLoadedTabs((tabsNames: string[]) => {
      tabsNames.push(newValue);
      return tabsNames;
    });
  };

  const setDefaultTabFromHash = () => {
    const hashName = hash.substring(1); // Remove first char '#'
    const isValidHash = tabs.some((tab) => tab.name === hashName);
    if (isValidHash) {
      setNewTab(hashName);
      pushAlreadyLoadedTabs(hashName);
    } else {
      const newTab = tabs[0].name;
      setValue(newTab);
      // Remove hash url
      window.history.replaceState(null, '', ' ');
      pushAlreadyLoadedTabs(newTab);
    }
  };

  useEffect(() => {
    setDefaultTabFromHash();
  }, []);

  const handleChange = (event: any, newValue: string) => {
    setNewTab(newValue);
    if (onChange) onChange(newValue);
    if (!alreadyLoadedTabs.includes(newValue)) {
      pushAlreadyLoadedTabs(newValue);
      if (onFirstTimeTabIsLoaded) onFirstTimeTabIsLoaded(newValue);
    }
  };

  if (!value || !tabs.length) return null;
  return (
    <>
      <div style={{ paddingBottom: '1rem' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="basic tabs example"
        >
          {
            tabs.map((tab) => (
              <Tab
                key={tab.name}
                label={tab.label}
                value={tab.name}
                icon={tab.icon}
                iconPosition={tab.iconPosition}
                disabled={tab.disabled}
              />
            ))
          }
        </Tabs>
      </div>
      {
        tabs.find((tab) => tab.name === value)?.content
      }
    </>
  );
}

export default TabsOrganize;
